module.exports = __webpack_public_path__ + "img/商家轮播.2f7ae4d1.png";